import {transferLanguage, unescapeHtmlTag} from "../../../../../core/utils/tools";
import React from "react";
import {useSelector} from "react-redux";


const PreviewTitle = ({selectedItem, title, currentColor, type}) => {
  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const langData = useSelector(state => state.theme.langData);
  const partCode = selectedItem?.partSwitch?.partCategory;
  const hasColor = Boolean(sendData[partCode]?.DIFFUSE);

  const getSelectedItemName = () => {
    return selectedItem
      ? unescapeHtmlTag(selectedItem[langData.langName])
      : transferLanguage(langData.lang, "noSelect");
  }

  const renderColorType = () => (
    <>
      <h3>{unescapeHtmlTag(title)}</h3>
      <p>
        {sendData && currentColor
          ? unescapeHtmlTag(currentColor.TITLE)
          : transferLanguage(langData.lang, "noSelect")
        }
      </p>
    </>
  );


  const renderPartType = () => {
    const itemName = getSelectedItemName();

    return hasColor ? (
      <>
        <h3>{itemName}</h3>
        <p>{sendData[partCode]?.COLORNAME}</p>
      </>
    ) : (
      <p>{itemName}</p>
    );
  };


  return (
    <div className="option-value-name">

      {type === "COLOR" && renderColorType()}
      {type === "PART" && renderPartType()}
    </div>
  )
}

export default PreviewTitle;
